import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RefIconComponent } from './ref-icon.component';



@NgModule({
    declarations: [
        RefIconComponent
    ],
    exports: [
        RefIconComponent
    ],
    imports: [
        CommonModule
    ]
})
export class RefIconModule { }
